import { GridColDef } from "@mui/x-data-grid";

export const genotypingSamplersInventoryColumns: GridColDef[] = [
	{
		headerName: 'Organisation',
		field: 'organisation',
		type: 'string',
		flex: 1,
	},
	{
		headerName: 'Nom',
		field: 'displayName',
		type: 'string',
		flex: 1,
	},
	{
		headerName: 'Code préleveur',
		field: 'samplerNumber',
		type: 'string',
		flex: 1,
	},
	{
		headerName: 'Nb prélèvements',
		field: 'countSample',
		type: 'number',
		flex: 1,
	},
];
